import { useEffect, useState } from "react";

function normalizeSortValue(value) {
  if (value == null) return "";
  if (typeof value === "number") return value;
  if (typeof value === "boolean") return value ? 1 : 0;

  const text = String(value).trim();
  if (!text) return "";

  const numeric = Number(text.replace(/,/g, ""));
  if (!Number.isNaN(numeric) && /^[-+]?\d[\d,.]*$/.test(text)) {
    return numeric;
  }

  const dateValue = Date.parse(text);
  if (!Number.isNaN(dateValue) && /(\d{4}|\d{1,2}[/-]\d{1,2})/.test(text)) {
    return dateValue;
  }

  return text.toLowerCase();
}

export function sortRowsByConfig(rows, sortConfig, accessors) {
  if (!sortConfig) return rows;

  const getValue = accessors[sortConfig.columnIndex];
  if (!getValue) return rows;

  return [...rows].sort((left, right) => {
    const leftValue = normalizeSortValue(getValue(left));
    const rightValue = normalizeSortValue(getValue(right));

    if (leftValue < rightValue) {
      return sortConfig.direction === "asc" ? -1 : 1;
    }
    if (leftValue > rightValue) {
      return sortConfig.direction === "asc" ? 1 : -1;
    }
    return 0;
  });
}

export default function useClientTableSort(tableRef, onSort) {
  const [sortConfig, setSortConfig] = useState(null);

  useEffect(() => {
    const table = tableRef.current;
    if (!table) return undefined;

    const handleClientSort = (event) => {
      const nextConfig = {
        columnIndex: event.detail.columnIndex,
        direction: event.detail.direction,
      };

      setSortConfig(nextConfig);
      if (typeof onSort === "function") onSort(nextConfig);
    };

    table.addEventListener("nw-client-sort", handleClientSort);
    return () => table.removeEventListener("nw-client-sort", handleClientSort);
  });

  return sortConfig;
}
